export default (vars) => ({
  noItemsText: 'Brak wyników',
  sidebarLabel: 'Podgląd',
  mainTabLabel: 'Formularz',
  afterItemsSetHook: () => {},
  initItem: () => ({}),
  ...vars,
});
